import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, image, url, type = 'website' }) => {
  const siteName = 'Arvaron Group';
  const defaultDescription = 'Arvaron is a Mumbai-based holding group operating across sourcing, logistics, digital, infrastructure, retail, technology, and exports — built for scale.';
  const defaultImage = 'https://arvaron-refresh.com/og-image.png';
  const baseUrl = 'https://arvaron-refresh.com';

  const seoTitle = title ? `${title} | ${siteName}` : `${siteName} — A Global Business Group`;
  const seoDescription = description || defaultDescription;
  const seoImage = image || defaultImage;
  const seoUrl = url ? `${baseUrl}${url}` : baseUrl;

  return (
    <Helmet>
      <title>{seoTitle}</title>
      <meta name="description" content={seoDescription} />
      <link rel="canonical" href={seoUrl} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:url" content={seoUrl} />
      <meta property="og:site_name" content={siteName} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      <meta name="twitter:image" content={seoImage} />

      {/* Additional */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content="Arvaron Group" />
      <meta name="keywords" content="Arvaron, holding company, Mumbai, logistics, sourcing, exports, technology, digital marketing, real estate, retail, India" />
    </Helmet>
  );
};

export default SEO;
